import React, { useEffect, useReducer, useState } from 'react';
import { FormCheckbox, Loader, ProviderConsumer as FluentUIThemeConsumer } from "@fluentui/react-northstar";
import { NestedDropdown } from '../NestedDropdown/NestedDropdown';
import { useTranslation } from 'react-i18next';
import { LabelElement } from '../TicketForm';
import { appState } from '../../../AppState';
import { clone } from "lodash";
import {IResolution, ValidateResolutionDetails, resolutionDetailsEmpty, defaultResolution} from './ResolutionHelper';
import { ADMINISTRATORS, ANALYSTS, KNOWLEDGEAGENT, STATUS_GUID } from '../../utils/constants';
import './style.css';
import SlateEditor from '../Wysiwyg/SlateEditor';
import { themeNames } from '@fluentui/react-teams';
import { getStatusIdByGuid } from '../../../tikit/ticketHelper';
import { platformService } from '../../services/platform.service';
import useUnsavedChangesWarning from '../../hooks/useUnsavedChangesWarning';
import { markdownToSlate, slateToMd } from '../Wysiwyg/slate-editor-helpers';

export const ResolutionDetails = (props: IResolution) => {
    const state = appState();
    const api = new platformService();
    const { t } = useTranslation();
    const currentState = appState();

    const [Prompt, setDirty] = useUnsavedChangesWarning();
    const setFormDirty: (boolVlaue: boolean) => void = setDirty as (boolVlaue: boolean) => void;

    const [isResolutionRole, setIsResolutionRole] = useState(false);
    const [isLoaded, setIsLoaded] = useState(false);
    const [isReadOnly, setIsReadOnly] =  useState(props.isReadOnly);
    const [isEditorReady, setIsEditorReady] = useState(false);

    const resolvedStatusId = getStatusIdByGuid(currentState.ticketStatus, STATUS_GUID.RESOLVED);

    const actionEnums = {
        AssignResolution: 'AssignResolution',
        UpdateResolution: 'UpdateResolution'
    }
    const entityTicketReducer = (resolutionState : ResolutionDetail, action) => {
        switch (action.action) {
        case "AssignResolution":
            resolutionState = action.data;
            return {
                ...resolutionState
            };
          case actionEnums.UpdateResolution:
            resolutionState[action.property] = action.data;
            return {
              ...resolutionState
            };
          default:
            return {
              ...resolutionState
            };
        }
      
      }

    const [resolutionState, dispatch] = useReducer(entityTicketReducer, defaultResolution);

    useEffect(()=>{
        if (!props.isEndUser)
        {
            let isDirtry = ValidateResolutionDetails(props.ticketData,resolutionState, props.resolutionNoteConfig, props.isDialog);
            setFormDirty(isDirtry);
            if (props.setEnableSaveBtn) props.setEnableSaveBtn(isDirtry);
            if (props.setUpdatedResolution) props.setUpdatedResolution(resolutionState);
    
            if (props.change)
                props.change(resolutionState);
        }
        
        
    },[props.ticketData, resolutionState.Note, resolutionState.InternalNote, resolutionState.ResolutionCategoryId, resolutionState.DraftKB]);
    
    useEffect(()=>{
        if (props.isDialog) {
            setIsReadOnly(false);
        } else {
            const notResolve = props.ticketData?.StatusId != resolvedStatusId;
            setIsReadOnly(notResolve ? true : props.isReadOnly);
        }

        
    },[props.ticketData?.StatusId, resolutionState, props.isReadOnly]);

    useEffect(()=>{
        if (props.isBulkEdit){
            if (!isLoaded) loadData();
        }
        else loadData();
    },[props.ticketData.Resolution]);

    useEffect(()=>{
        if (props.reset){
            setIsLoaded(false);
            loadData();
            if (props.resetEvent) props.resetEvent()

        }
    },[props.reset]);

    const loadData = async () => {
        let resolution=null;
        if (props.ticketData?.Id){
            resolution = (await api.getTicket(props.ticketData?.Id,`?$select=ResolutionId&$expand=Resolution`))?.data?.Resolution;
        
            if (resolution){
                dispatch({ action: actionEnums.AssignResolution, data: resolution});
            }
            else dispatch({ action: actionEnums.AssignResolution, data: clone(resolutionDetailsEmpty())});
        }
        else dispatch({ action: actionEnums.AssignResolution, data: clone(resolutionDetailsEmpty())});
        
        
        let currentSelectedId = resolution?.ResolutionCategoryId ?? 0;
        props.ticketData.Resolution = props.ticketData.Resolution ?? resolutionDetailsEmpty();
        let selectedCat = clone(state.resolutionCategory.find(x=>x.Id==currentSelectedId || (!props.resolutionNoteConfig.RequireCategory && props.ticketData.ResolutionId==null && x.IsDefault)));
        
        dispatch({ action: actionEnums.UpdateResolution, property:"ResolutionCategory", data: selectedCat ?? null});
        dispatch({ action: actionEnums.UpdateResolution, property:"ResolutionCategoryId", data: selectedCat?.Id ?? null});


        if (props.resolutionNoteConfig.RequireCategory && currentSelectedId==null) props.ticketData.Resolution.ResolutionCategory=null;
        setIsResolutionRole(currentState.userRoles.roles.some(x=>[ADMINISTRATORS,ANALYSTS,KNOWLEDGEAGENT].includes(x)));

        setIsLoaded(true);
        if (props.loaded) props.loaded();
        
    }

    return (<FluentUIThemeConsumer
            render={globalTheme => (
                <div className='resolution-container'>
                    {(!isLoaded) && 
                        <div className={`pt-5 mt-5 res-loader`}>
                            <Loader />
                        </div>
                    }
                    {isLoaded && 
                        <>
                        {!props.isEndUser &&
                        <LabelElement required={props.resolutionNoteConfig.RequireCategory} label={t('resolution-note.resolution-category')}>
                            <NestedDropdown
                                disabled={isReadOnly || props.isEndUser}
                                tabIndex={0}
                                showClearBtn={true}
                                items={state.resolutionCategory.map(item => ({
                                    id: item.Id,
                                    parentId: item.ParentId,
                                    position: item.Position,
                                    value: item.Value,
                                    ...item
                                }))}
                                dataItem={{
                                    id: resolutionState?.ResolutionCategory?.Id,
                                    parentId: resolutionState?.ResolutionCategory?.ParentId,
                                    position: resolutionState?.ResolutionCategory?.Position,
                                    value: resolutionState?.ResolutionCategory?.Value,
                                    ...resolutionState?.ResolutionCategory
                                }}
                                defaultValue={resolutionState?.ResolutionCategory?.Value}
                                onChange={value => {
                                    let _clone = clone(state.resolutionCategory.find(x=>x.Id==value?.id));
                                    dispatch({ action: actionEnums.UpdateResolution, property:"ResolutionCategoryId", data: _clone?.Id ?? null});
                                    dispatch({ action: actionEnums.UpdateResolution, property:"ResolutionCategory", data: _clone ?? null});
                                }}
                            />
                        </LabelElement>
                        }
                        
                        <LabelElement required={props.resolutionNoteConfig.RequireNote} className='sub-container' label={t('resolution-note.resolution-note')}>
                            <SlateEditor
                                disabled={isReadOnly || props.isEndUser}
                                onChange={(data)=>{
                                    if(isEditorReady)
                                    {
                                        let mk = slateToMd(data);
                                        dispatch({ action: actionEnums.UpdateResolution, property:"Note", data: mk});
                                    }
                                    setIsEditorReady(true);
                                }}
                                slateValue={markdownToSlate(resolutionState?.Note)}
                                noImage={true}
                                isFocus={true}
                                minHeight='8.4rem'
                                noHeaders
                                className={globalTheme.siteVariables.theme===themeNames.Dark ? 'slate-resolution-note-dark' : 'slate-resolution-note'}
                            />
                        </LabelElement>
                        {!props.isEndUser && 
                            <>
                                <LabelElement required={props.resolutionNoteConfig.RequireInternalNote} className='sub-container' label={t('resolution-note.resolution-note-internal')}>
                                    <SlateEditor
                                        disabled={isReadOnly}
                                        onChange={(data)=>{
                                            let mk = slateToMd(data);
                                            dispatch({ action: actionEnums.UpdateResolution, property:"InternalNote", data: mk});
                                        }}
                                        slateValue={markdownToSlate(resolutionState?.InternalNote)}
                                        noImage={true}
                                        isFocus={false}
                                        noHeaders
                                        minHeight='8.4rem'
                                        className={globalTheme.siteVariables.theme===themeNames.Dark ? 'slate-resolution-note-dark' : 'slate-resolution-note'}
                                    />
                                </LabelElement>
                                <FormCheckbox
                                    disabled={props.disableDraftKB || isReadOnly || props.ticketData?.Resolution?.AnswerId!=null}
                                    hidden={!props.resolutionNoteConfig.ShowDraftKB || !isResolutionRole}
                                    label={props.isBulkEdit ? t('resolution-note.draft-kb-bulk-edit') : t('resolution-note.draft-kb')}
                                    checked={resolutionState.DraftKB}
                                    onChange={(_, checked) => {
                                        dispatch({ action: actionEnums.UpdateResolution, property:"DraftKB", data: checked.checked});
                                    }}
                                />
                            </>
                        }
                        
                        </>
                    }
                    {Prompt}
                </div>
            )} 
            
        />);
}